import { ConsumptionWidget } from './revenueShared';

export const LastDayRevenue = () => <ConsumptionWidget period="TODAY" titleKey="consumptionTodayTitle" />;
